/*=========================================================================================
  File Name: getters.js
  namespace: collections
  Description: Vuex Store - Collection getters
==========================================================================================*/

const getters = {
  getCurrentCollection: (state) => {
    return state.currentCollection
  },
  collectionsCsv: (state) => {
    return state.collectionsCsv
  },
  getCollectionStructure: (state) => {
    return state.content
  },
  collectionIsPublished: (state) => {
    return (
      state.currentCollection.status !==
      state.COLLECTION_POSSIBLE_STATUS.PUBLISHED
    )
  },
  getCollectionPossibleStatus: (state) => {
    return state.collectionStatusTransitions[
      state.currentCollection.status
    ].map((value) => {
      return {
        label:
          value.charAt(0).toUpperCase() +
          value.slice(1).toLowerCase().replace(/_/g, ' '),
        value: value,
      }
    })
  },
  getCollectionAllStatus: (state) => {
    return Object.entries(state.COLLECTION_POSSIBLE_STATUS).map(([, value]) => {
      return {
        label:
          value.charAt(0).toUpperCase() +
          value.slice(1).toLowerCase().replace(/_/g, ' '),
        value: value,
      }
    })
  },
  getCollectionStatusList: (state) => {
    return state.COLLECTION_POSSIBLE_STATUS
  },
  getCollectionDifficulties: (state) => {
    return Object.entries(state.COLLECTION_POSSIBLE_DIFFICULTY).map(
      ([, value]) => {
        return {
          label: value.charAt(0).toUpperCase() + value.slice(1).toLowerCase(),
          value: value,
        }
      }
    )
  },
  getCollectionEntries: (state) => {
    return state.collectionList
  },
  getCollectionList: (state) => {
    return {
      results: state.results,
      count: state.count,
    }
  },
  getStatusTransitions: (state) => {
    return state.collectionStatusTransitions
  },
  getCurrentCollectionPasses: (state) => {
    return state.currentCollection.direct_passes
  },
  getHundredCollections: (state) => {
    return state.hundredCollections
  },
}

export default getters
